import { useMutation } from "@tanstack/react-query";
import { api } from "jiffy-api";
import { objNamesToSnakeCase, objNamesToCamelCase } from "common/utils/helpers/cases";

export interface CreateLlmRedrawRequestParams {
  dtfArtworkId: number;
  initialPrompt: string;
}

export interface CreateLlmRedrawRequestResponse {
  id: number;
  clarifyingQuestions: Array<{
    question?: string;
    text?: string;
    title?: string;
    options: string[];
  }>;
  success: boolean;
}

export interface UpdateLlmRedrawRequestParams {
  id: number;
  followUpQuestionsAndResponses: Record<string, string | undefined>;
}

export function useCreateLlmRedrawRequest(artworkId: number, side?: string) {
  return useMutation({
    mutationKey: side ? ["llmRedrawRequest", artworkId, side] : ["llmRedrawRequest", artworkId],
    mutationFn: async (
      params: CreateLlmRedrawRequestParams
    ): Promise<CreateLlmRedrawRequestResponse> => {
      const response = await api.llmRedrawRequests.create(
        objNamesToSnakeCase({
          llmRedrawRequest: params
        })
      );

      return objNamesToCamelCase(response);
    }
  });
}

export function useUpdateLlmRedrawRequest(artworkId: number, side?: string) {
  return useMutation({
    mutationKey: side ? ["llmRedrawRequest", artworkId, side] : ["llmRedrawRequest", artworkId],
    mutationFn: async (params: UpdateLlmRedrawRequestParams): Promise<void> => {
      await api.llmRedrawRequests.update(
        { id: params.id },
        objNamesToSnakeCase({
          llmRedrawRequest: {
            followUpQuestionsAndResponses: params.followUpQuestionsAndResponses
          }
        })
      );
    }
  });
}
